import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ModuleConfiguration } from '../../datawarehouse.module.config';
import { IDataWarehouseState } from '../states/IDataWarehouseState';
import { dataWarehouseReducer } from './datawarehouse.reducer';
import { IDataWarehouseEditorState } from '../states/IDataWarehouseEditorState';
import { dataWarehouseEditorReducer } from './datawarehouse-editor.reducer';

export interface IDataWarehouseModuleState {
  dataWarehouseState: IDataWarehouseState,
  dataWarehouseEditorState: IDataWarehouseEditorState
};

export const reducers = {
  dataWarehouseState: dataWarehouseReducer,
  dataWarehouseEditorState: dataWarehouseEditorReducer 
};

export const getDataWarehouseModuleState = createFeatureSelector(ModuleConfiguration.moduleName);

export const getDataWarehouseState = createSelector(getDataWarehouseModuleState, (s: IDataWarehouseModuleState) => s.dataWarehouseState);
export const getDataSetsLoading = createSelector(getDataWarehouseState, s => s.dataSetsLoading);
export const getDataSetsTotalCount = createSelector(getDataWarehouseState, s => s.dataSetsTotalCount);
export const getDataSets = createSelector(getDataWarehouseState, s => s.dataSets);

export const getDataWarehouseEditorState = createSelector(getDataWarehouseModuleState, (s: IDataWarehouseModuleState) => s.dataWarehouseEditorState);


export const getListEditorsState = createSelector(getDataWarehouseEditorState, s => s.listEditors);
export const getSubmittingEntity = createSelector(getDataWarehouseEditorState, s => s.submittingEntity);
export const getListEditor = (k: string,p: string) => createSelector(getListEditorsState, s => !s[`${k}_${p}`] ? {} : s[`${k}_${p}`]) 
export const getEntityListMetadata = (k: string,p: string) => createSelector(getListEditor(k,p), s => s.listMetadata);
export const getEntitiesList = (k: string,p: string) => createSelector(getListEditor(k,p), s => s.list);
export const getEntitiesListTotalCount = (k: string,p: string) => createSelector(getListEditor(k,p), s => s.totalCount);
export const getEditorStateLoading = (k: string,p: string) => createSelector(getListEditor(k,p), s => s.loading);
export const getEntitiesListErrors = (k: string,p: string) => createSelector(getListEditor(k,p), s => s.errors);
export const getEntitiesSelection = (k: string,p: string) => createSelector(getListEditor(k,p), s => s.selected);
export const getEntitiesSubmittingEntityKey = (k: string,p: string) => createSelector(getListEditor(k,p), s => s.submittingEntityKey);






// WEBPACK FOOTER //
// ./src/app/datawarehouse/store/reducers/index.ts